import React, { useEffect, useState } from 'react'
import { Autocomplete, FormControl, TextField } from '@mui/material'
import { useLang } from '~/hooks/useLang'
import { getUnitMeasurement } from '~/features/UnitMeasurement/services'

interface FilterAutocompleteUnitMeasurementProps {
  readonly onUnitMeasurementChange: (value: number | null) => void
  readonly unitMeasurementId?: number | null
  readonly disabled?: boolean
}

export default function FilterAutocompleteUnitMeasurement({ disabled, unitMeasurementId, onUnitMeasurementChange }: FilterAutocompleteUnitMeasurementProps) {
  const { translate } = useLang()
  const [options, setOptions] = useState<readonly any[]>([])
  const [value, setValue] = useState<any | null>(null)

  useEffect(() => {
    getUnitMeasurement().then((data) => {
      // getUnitMeasurement returns response.data.data
      setOptions(data ?? [])
      setValue(null)
    })
  }, [])

  useEffect(() => {
    if (!unitMeasurementId) {
      setValue(null)
    } else {
      setValue(options.find((opt) => opt.id === unitMeasurementId) ?? null)
    }
  }, [unitMeasurementId, options])

  return (
    <FormControl fullWidth size="small">
      <Autocomplete
        id="filter-unit-measurement"
        disabled={disabled}
        options={options}
        value={value}
        noOptionsText={translate('No options')}
        size="small"
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(option) => option.name ?? ''}
        onChange={(_, type) => {
          setValue(type)
          onUnitMeasurementChange(type?.id as number ?? null)
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={translate('Unit Measurement')}
          />
        )}
      />
    </FormControl>
  )
}
